<template>
  <div class="outlineClass">
    <div class="part1" oncontextmenu = "return false" oncopy = "return false" onselectstart = "return false">
      <div class="cooperationPart1"></div>
      <div class="cooperationPart2"></div>
      <div class="cooperationPart3"></div>
      <div class="cooperationPart4"></div>
    </div>
    <div class="part5" style="display: none" v-show="vShow">
      <span style="color:white">Copyright ©2019 创益星 版权所有 <a  style="color:white" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备19070479号-1</a>  江苏中尚机器人科技有限公司</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "cooperation",
        data(){
          return{
            vShow:false,
          }

        },
          mounted(){
          window.setInterval(this.vShow=true,3000);
        }

    }
</script>

<style scoped>
.part1{
  width: 100%;
  min-height: 1000px;
}
  .cooperationPart1{
    min-height: 940px;
    background: url("../../assets/images/cooperation/cooperation_part1.png");
  }
.cooperationPart2{
  min-height: 778px;
  background: url("../../assets/images/cooperation/cooperation_part2.png");
}
.cooperationPart3{
  min-height: 1623px;
  background: url("../../assets/images/cooperation/cooperation_part3.png");
}
  .cooperationPart4{
    min-height: 867px;
    background: url("../../assets/images/cooperation/cooperation_part4.png");
  }
</style>



// WEBPACK FOOTER //
// src/components/cooperation/chineseCooperation.vue